import { isApp } from '~/js/helpers/user-agent-helper'

const sendId = async (memberObj, redirectTo, retryCount = 5) => {
  return new Promise((resolve, reject) => {
    // eslint-disable-next-line no-undef
    Yappli.sendRegisteredId(memberObj, async function (result) {
      if (result) {
        resolve(result)
        window.location.href = redirectTo
      } else {
        if (retryCount <= 0) {
          reject()
          throw new Error('Failed to send Yappli ID')
        }
        sendId(memberObj, redirectTo, --retryCount)
      }
    })
  })
}

export const sendYappliId = async ({ registeredId, token }) => {
  if (!isApp()) return
  const { deepLinkMemberCard } = document.getElementById('js-data').dataset
  sendId(
    JSON.stringify({
      registered_id: registeredId,
      token,
    }),
    deepLinkMemberCard
  )
}
